import { Button } from "@mui/material";
import colors from "../../theme/themeConstants";
import { ReactComponent as BurgerIcon } from "../icons/burgerIcon.svg";

interface IProps {
  onClick?: () => void;
}

export function HeaderButton({ onClick }: IProps) {

  return (
    <Button variant="contained"
      onClick={onClick}
      sx={{
        borderRadius: "25px",
        height: "1rem",
        minHeight: "36px",
        width: "1rem",
        minWidth: "36px",
        background: colors.purpleGradient,
        marginLeft: "12px",
        padding: "0",
        "svg": {
          width: "16px",
          height: "auto"
        },
        "&:hover": {
          cursor: "pointer",
          background: "none",
          border: "1px solid #8F2CF2"
        },
        ".desktop &": {
          marginLeft: "auto",
          justifyContent: "center",
        },
      }}>
      <BurgerIcon />
    </Button >
  );
}

